import { render, staticRenderFns } from "./ExtractFormInput.vue?vue&type=template&id=36c34fa7&scoped=true&"
import script from "./ExtractFormInput.vue?vue&type=script&lang=ts&"
export * from "./ExtractFormInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c34fa7",
  null
  
)

export default component.exports